import React, { useState } from "react";
import "../styles/EggHierarchyTable.css"; // CSS 분리

function EggHierarchyTable({ agencyTree , handleAction,amountInput, setAmountInput}) {
  const [expanded, setExpanded] = useState({});

  const handleAmountChange = (id, value) => {
    setAmountInput({ ...amountInput, [id]: value });
  };

  const amounts = [
    { label: "십만", value: 100000 },
    { label: "백만", value: 1000000 },
    { label: "천만", value: 10000000 },
    { label: "오천만", value: 50000000 },
    { label: "일억", value: 100000000 },
  ];

  const handleChild = (sort,id, type) => {
    console.log(sort+" " +id + " "+type );
    handleAction(sort, id, type);
  };

    
  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const renderRow = (user, depth = 0) => (
    <React.Fragment key={user.id}>
      <tr style={{ backgroundColor: depth === 1 ? "#f9f9f9" : "white" }}>
        <td >
          {user.children?.length > 0 && (
            <button className="toggle-btn" onClick={() => toggleExpand(user.id)}>
              {expanded[user.id] ? "▼" : "▶"}
            </button>
          )}
          {user.username}
        </td>
        <td>{user.type}</td>
        <td>{user.egg.toLocaleString()}</td>
        <td>
          {
          amounts.map(({ label, value }) => (
            <button
              key={label}
              onClick={() => handleAmountChange(user.id, value)}
              className="amount-btn"
            >
              {label}
            </button>
          ))}
          <input
            className="direct-input"
            type="number"
            value={amountInput[user.id] || ""}
            onChange={(e) => handleAmountChange(user.id, e.target.value)}
          />
          <button className="give-btn" onClick={() => handleChild('give', user.id,user.type)}>지급</button>
          <button className="take-btn" onClick={() => handleChild('take', user.id,user.type)}>회수</button>
        </td>
      </tr>
      {expanded[user.id] &&
        user.children?.map((child) => renderRow(child, depth + 1))}
    </React.Fragment>
  );

  return (
    <table className="egg-table">
      <thead>
        <tr>
          <th>유저</th>
          <th>권한 등급</th>
          <th>보유 알</th>
          <th>지급/회수</th>
        </tr>
      </thead>
      <tbody>
        {agencyTree.map((agency) => renderRow(agency))}
      </tbody>
    </table>
  );
}

export default EggHierarchyTable;